import { render, staticRenderFns } from "./soft2d.vue?vue&type=template&id=5c11e47a&scoped=true"
import script from "./soft2d.vue?vue&type=script&lang=js"
export * from "./soft2d.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c11e47a",
  null
  
)

export default component.exports